import React from 'react';
import { SearchIcon, BellIcon, SunIcon, MoonIcon } from './userDashboard/theme';
import { useTheme } from './ThemeContext';
import useResponsive from './userDashboard/ResponsiveHook'; // ✅ Import du hook responsive

const logoImg = process.env.PUBLIC_URL + '/702844604_2344407339420357_5425605054250800936_n.jpg';

export default function Topbar({ title = "Dashboard", onMenuClick }) { // ✅ Ajout de onMenuClick
    const { C, isDark, toggleTheme } = useTheme();
    const { isMobile } = useResponsive(); // ✅ Détection mobile/tablette

    return (
      <header style={{
        display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px",
        padding: isMobile ? "12px 16px" : "14px 28px", // ✅ Padding réduit sur mobile
        borderBottom: `1px solid ${C.border}`,
        background: C.bgDeep, 
        position: "sticky", top: 0, zIndex: 40,
        boxSizing: "border-box", width: "100%"
      }}>
        <img src={logoImg} alt="Logo" style={{ width: 32, height: 32, borderRadius: 8, marginRight: 8, objectFit: "cover" }} />
        
        {/* Section Titre + Burger */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
          {/* ✅ Bouton Burger visible uniquement sur Mobile / Tablette */}
          {isMobile && (
            <button 
              onClick={onMenuClick}
              style={{
                background: "none", border: "none", color: C.textPrimary,
                fontSize: 20, cursor: "pointer", display: "flex", 
                alignItems: "center", justifyContent: "center", padding: 4
              }}
            >
              ☰
            </button>
          )}
          
          <span style={{ 
            fontFamily: "'Space Mono', monospace", 
            fontSize: isMobile ? 14 : 15, 
            fontWeight: 700, 
            color: C.textPrimary,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}>
            {title}
          </span>
        </div>
  
        {/* ✅ Section Recherche - Masquée sur mobile pour éviter les débordements sur Mobile S */}
        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center", flex: 1, maxWidth: 300, position: "relative" }}>
            <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}>
              <SearchIcon color={C.textSecond} />
            </span>
            <input type="text" placeholder="Search tests, jobs…" style={{
              width: "100%", background: C.bgCard,
              border: `1px solid ${C.border}`, borderRadius: 8,
              color: C.textSecond, fontSize: 13,
              padding: "8px 14px 8px 36px", fontFamily: "inherit", outline: "none", margin: 0,
            }} />
          </div>
        )}
  
        {/* Section Actions / Boutons */}
        <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 8 : 10, flexShrink: 0 }}>
          <button style={{
            width: 34, height: 34, background: C.bgCard, // Légèrement réduit pour mobile S
            border: `1px solid ${C.border}`, borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: C.textSecond,
          }}>
            <BellIcon />
          </button>
          
          <button onClick={toggleTheme} style={{
            width: 34, height: 34, background: C.bgCard,
            border: `1px solid ${C.border}`, borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: C.amber,
          }}>
            {isDark ? <SunIcon /> : <MoonIcon />}
          </button>

          <img src={logoImg} alt="Logo" style={{ width: 32, height: 32, borderRadius: 8, marginRight: 8, objectFit: "cover" }} />
        </div>
      </header>
    );
}